// extracted by mini-css-extract-plugin
module.exports = {"root":"Spinner_root__11e7L","rotate":"Spinner_rotate__1RwRo"};